module.exports = __webpack_public_path__ + "img/dj.1457f6c8.svg";